export const isEditLocked = (status) => {
  if (!status) return false;                                   // don’t lock while loading

  const { subscription = {}, onboarding_completed } = status;
  const { plan, end_date } = subscription;

  // ⬇️ 1. lock only if the subscription itself has expired
  const expired = !!end_date && Date.now() > new Date(end_date).getTime();

  // ⬇️ 2. for trial users, lock after the first successful onboarding
  const trialUsed = plan === "trial" && onboarding_completed;

  // ⬇️ 3. essentials users are **never** locked here;
  //        credits are handled separately when they click “Continue”
  return expired || trialUsed;
};